// extracted by mini-css-extract-plugin
export default {"price":"Q4-z","onSale":"R4-z","msrpLabelPrice":"S4-z","msrpLabel":"T4-z","originalPrice":"U4-z","percentOff":"V4-z"};